import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=47b5549e"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b5549e')) {
      api.createRecord('47b5549e', component.options)
    } else {
      api.reload('47b5549e', component.options)
    }
    module.hot.accept("./Photos.vue?vue&type=template&id=47b5549e", function () {
      api.rerender('47b5549e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/user/Photos.vue"
export default component.exports